import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import Tools from './tools';

export default class News {
  constructor() {
    // News

    this.slider('.post-it-wrapper');
    this.slider('.a-la-une-wrapper');
    this.manageDisplay();
    this.homeNews();
  }

  slider(element) {
    if (document.querySelector(element)) {
      tns({
        container: element,
        slideBy: 'page',
        autoplay: true,
        // autoplay: false,
        autoplayTimeout: 7000,
        autoplayHoverPause: true,
        loop: true,
        navPosition: 'bottom',
        preventActionWhenRunning: true,
        // controlsText: [
        //   '',
        //   '',
        // ],
        controls: false,
      });
    }
  }

  manageDisplay() {
    const btn = document.querySelector('section.actus .toggle-news');
    const actusWrapper = document.querySelector('section.actus');
    if (btn) {
      btn.addEventListener('click', () => {
        if (actusWrapper.classList.contains('open')) {
          actusWrapper.classList.remove('open');
          Tools.autoToZero(actusWrapper.querySelector('.actus-container'));
          setTimeout(() => {
            actusWrapper.querySelector('.toggle-news span').innerText = 'Actualités';
          }, 500);
        } else {
          actusWrapper.classList.add('open');
          Tools.zeroToAuto(actusWrapper.querySelector('.actus-container'));
          setTimeout(() => {
            actusWrapper.querySelector('.toggle-news span').innerText = 'Réduire';
          }, 500);
        }
      });
    }
  }

  delete_cookie( name, path, domain ) {
    if( this.get_cookie( name ) ) {
      document.cookie = name + "=" +
        ((path) ? ";path="+path:"")+
        ((domain)?";domain="+domain:"") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  }

  get_cookie(name){
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
  }

  homeNews() {
    if (document.body.classList.contains('home')) {
      document.querySelector('section.actus').classList.add('open');
      document.querySelector('section.actus .toggle-news span').innerText = 'Réduire';
      // document.querySelector('section.actus .actus-container').style.height = 'auto';

      setTimeout(() => {
        document.querySelector('section.actus').classList.remove('open');
        document.querySelector('section.actus .toggle-news span').innerText = 'Actualités';
        Tools.autoToZero(document.querySelector('section.actus .actus-container'));
      }, 120000);
    }
  }
}